import { render, staticRenderFns } from "./ProjectsListItem.vue?vue&type=template&id=39434426&scoped=true"
import script from "./ProjectsListItem.vue?vue&type=script&lang=js"
export * from "./ProjectsListItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectsListItem.vue?vue&type=style&index=0&id=39434426&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39434426",
  null
  
)

export default component.exports